// extracted by mini-css-extract-plugin
module.exports = {"imsFormat_wrapper":"imsFormat_imsFormat_wrapper__lRpqd","ims_table":"imsFormat_ims_table__cNvyh","countBtn":"imsFormat_countBtn__1DR_M","format_btn":"imsFormat_format_btn__2RuLR"};